export default function map() {
  const mapWrapper = document.querySelector('.about-map')

  if (mapWrapper) {
    const map = mapWrapper.querySelector('.map')
    const overlay = mapWrapper.querySelector('.--overlay')
    const icons = mapWrapper.querySelectorAll('.leaflet-marker-pane img')

    map.style.pointerEvents = 'none'
    map.style.opacity = '.6'

    icons.forEach(el => {
      el.style.pointerEvents = 'none'
    })

    // Disable scroll zooming and bind back the click event
    let onMapMouseleaveHandler = e => {
      e.target.addEventListener('click', onMapClickHandler)

      map.removeEventListener('mouseleave', () => {
        onMapMouseleaveHandler()
        onMapScroll()
      })

      map.style.pointerEvents = 'none'
      map.style.opacity = '.6'

      icons.forEach(el => {
        el.style.pointerEvents = 'none'
      })
    }

    let onMapClickHandler = e => {
      // Disable the click handler until the user leaves the map area
      e.target.removeEventListener('click', onMapClickHandler)

      // Enable scrolling zoom
      map.style.pointerEvents = 'auto'
      map.style.opacity = ''

      icons.forEach(el => {
        el.style.pointerEvents = 'auto'
      })

      // Handle the mouse leave event
      map.addEventListener('mouseleave', onMapMouseleaveHandler)
    }


    let onMapScrollOverHandler = () => {
      overlay.style.opacity = '1'

      setTimeout(() => {
        overlay.style.opacity = ''
      }, 2000)
    }

    // Enable map zooming with mouse scroll when the user clicks the map
    mapWrapper.addEventListener('mousedown', onMapClickHandler)
    mapWrapper.addEventListener('wheel', onMapScrollOverHandler)
  }
}